import { Rv, Kicker, Source } from "../ui";
import { FlowMap, ItalyMap, LngChain } from "../Maps";

export const S9 = () => (
  <div className="slide" data-testid="slide-9">
    <Kicker n="08">Le infrastrutture</Kicker>
    <Rv d={0.3}><h2 className="title">Piombino e <em>Ravenna</em>.</h2></Rv>
    <div className="s9-grid">
      <Rv d={0.6} className="italy-wrap"><ItalyMap /></Rv>
      <div className="s9-right">
        <Rv d={0.8}><LngChain /></Rv>
        <div className="stat-row">
          <Rv d={1.2} className="stat glass" data-testid="fsru-golar">
            <div className="card-k">Piombino · FSRU</div><h3>Golar Tundra</h3>
            <div className="fsru-nums"><div><b className="ice">5</b><span>mld m³/anno</span></div><div><b className="ice">170.000</b><span>m³ di stoccaggio GNL</span></div></div>
          </Rv>
          <Rv d={1.4} className="stat glass" data-testid="fsru-bw">
            <div className="card-k">Ravenna · FSRU</div><h3>BW Singapore</h3>
            <div className="fsru-nums"><div><b className="ice">≈5</b><span>mld m³/anno nominali</span></div></div>
          </Rv>
        </div>
      </div>
    </div>
    <Source>Snam S.p.A., Relazione Finanziaria Annuale 2023 e comunicati ufficiali</Source>
  </div>
);

const F21 = [{ from: "russia", name: "Russia", value: 29.2, color: "#ff5a1f", dx: -14, dy: -18, anchor: "end" }];
const F24 = [
  { from: "algeria", name: "Algeria", value: 23.3, color: "#ffb347", dy: 34, anchor: "middle", dx: 0 },
  { from: "azerbaigian", name: "Azerbaigian", value: 10.3, color: "#ff8a3a", dy: 32, dx: -12, anchor: "end" },
  { from: "qatar", name: "Qatar", value: 6.9, color: "#6cc5ff", dy: 30, dx: -10 },
  { from: "russia", name: "Russia", value: 5.7, color: "#c8401a", dy: -14, dx: -14, anchor: "end" },
  { from: "usa", name: "USA", value: 5.2, color: "#8fd3ff", dy: 32, dx: -10 },
];

export const S10 = () => (
  <div className="slide" data-testid="slide-10">
    <Kicker n="09">Prima e dopo</Kicker>
    <Rv d={0.3}><h2 className="title">2021 contro 2024: da un <em>flusso</em> a una <em>rete</em>.</h2></Rv>
    <div className="maps2">
      <Rv d={0.6} className="map-card">
        <div className="map-year">2021</div>
        <FlowMap flows={F21} testid="map-2021" delay={0.6} />
        <div className="cap">Un unico flusso dominante · ≈40% dell’import</div>
      </Rv>
      <Rv d={0.75} className="map-divider" data-testid="map-divider">
        <span className="map-divider-line" />
        <span className="map-divider-arrow">→</span>
        <span className="map-divider-line" />
      </Rv>
      <Rv d={0.9} className="map-card">
        <div className="map-year amber">2024</div>
        <FlowMap flows={F24} testid="map-2024" delay={1.2} />
        <div className="cap">Una rete distribuita di fornitori · mld m³</div>
      </Rv>
    </div>
    <Source>ARERA, Relazioni Annuali 2024 e 2025 · dati MASE</Source>
  </div>
);

export const S11 = () => (
  <div className="slide" data-testid="slide-11">
    <Kicker n="10">Finanza e strategia: oltre la crisi</Kicker>
    <div className="s11-grid">
      <Rv d={0.4} className="orbit-wrap" data-testid="orbit">
        <div className="orbit o1"><span className="sat"><b>Plenitude</b></span></div>
        <div className="orbit o2"><span className="sat"><b>Enilive</b></span></div>
        <div className="core">ENI</div>
      </Rv>
      <div className="s11-items">
        <Rv d={0.6} className="item"><div className="card-k">Modello satellitare</div><p><b>Plenitude</b> ed <b>Enilive</b>: attività valorizzate tramite società dedicate.</p></Rv>
        <Rv d={0.8} className="item"><div className="card-k">Nuovi investimenti</div><p>Capitale liberato, senza ricorrere soltanto a più debito.</p></Rv>
        <Rv d={1.0} className="item"><div className="card-k">Gennaio 2024</div><p>Acquisizione di <b>Neptune Energy</b>: rafforzamento dell'upstream e del gas.</p></Rv>
      </div>
    </div>
    <Rv d={1.5} className="conclusion" data-testid="conclusion">
      Da dipendenza <span className="strike">concentrata</span> a dipendenza <em>diversificata</em>.
    </Rv>
    <Source>ENI S.p.A., Relazione Finanziaria Annuale 2024 e comunicati ufficiali</Source>
  </div>
);

const BIB = [
  ["ARERA – Autorità di Regolazione per Energia Reti e Ambiente", "Relazione Annuale 2024 sullo stato dei servizi e sull'attività svolta", "2024"],
  ["ARERA – Autorità di Regolazione per Energia Reti e Ambiente", "Relazione Annuale 2025 sullo stato dei servizi e sull'attività svolta", "2025"],
  ["ARERA – Autorità di Regolazione per Energia Reti e Ambiente", "Comunicati ufficiali sui dati del mercato italiano del gas e sulle importazioni per Paese di provenienza", "s.d."],
  ["MASE – Ministero dell'Ambiente e della Sicurezza Energetica", "Dati ufficiali sulle importazioni di gas utilizzati nelle statistiche ARERA", "s.d."],
  ["ENI S.p.A.", "Relazione Finanziaria Annuale 2024 · Annual Report · Global Gas & LNG Portfolio", "2024"],
  ["ENI S.p.A.", "Comunicati ufficiali relativi ad Algeria, Mozambico, Congo LNG, Qatar e acquisizione di Neptune Energy", "s.d."],
  ["Snam S.p.A.", "Relazione Finanziaria Annuale 2023", "2023"],
  ["Snam S.p.A.", "Comunicati ufficiali relativi alle FSRU Golar Tundra e BW Singapore e alle infrastrutture italiane di rigassificazione", "s.d."],
];

export const S12 = () => (
  <div className="slide" data-testid="slide-12">
    <Kicker n="11">Fonti</Kicker>
    <Rv d={0.3}><h2 className="title">Bibliografia</h2></Rv>
    <ol className="bib" data-testid="bibliography">
      {BIB.map(([who, what, y], i) => (
        <Rv d={0.5 + i * 0.1} key={i}>
          <li data-testid={`bib-item-${i + 1}`}>
            <span className="bib-n">{String(i + 1).padStart(2, "0")}</span>{" "}
            <span className="bib-who">{who.endsWith(".") ? who : who + "."}</span> <i>{what}</i>. <span className="bib-y">{y.endsWith(".") ? y : y + "."}</span>
          </li>
        </Rv>
      ))}
    </ol>
    <Rv d={1.5} className="bib-note">Le interpretazioni economiche sono sviluppate a partire dai dati e dalle informazioni contenuti nelle fonti ufficiali. Tutti i grafici sono elaborazioni originali.</Rv>
  </div>
);
